import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { CreditReview } from './credit-review.entity';

export class CreateCreditReviewDto extends Omit(CreditReview, [...BaseEntityFieldsArray, 'status'], []) {}
